module.exports = __webpack_public_path__ + "static/media/step_007.00c60287.jpeg";